export const PropertyGroupHeader = ({ name }: { name: string }) => {
  if (!name) return null;
  return (
    <div className="bg-alpha-20 border-t border-b border-alpha-40 px-5 py-2 text-sm font-medium text-content-1000">
      {name}
    </div>
  );
};
